import * as React from 'react';

import { Button } from '@ui/components';

import './ButtonLogin.less';

interface Props {
  children: any;
  onClick: () => void;
  loading: boolean;
}

class ButtonLogin extends React.PureComponent<Props> {
  static defaultProps = {
    onClick: () => null,
  };

  render() {
    const { children, onClick, loading } = this.props;
    return (
      <Button
        type="primary"
        className="login-btn"
        size="large"
        onClick={onClick}
        htmlType="submit"
        loading={loading}
      >
        {children}
      </Button>
    );
  }
}

export default ButtonLogin;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/ButtonLogin/ButtonLogin.tsx